'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ProgressBar = require('./ProgressBar');

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _ProgressBar2["default"];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/bee-progress-bar/build/index.js
// module id = 642
// module chunks = 0